<template>
  <div class="animate-shimmer rounded-lg overflow-hidden">
    <div
      class="h-48 bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 dark:from-gray-700 dark:via-gray-600 dark:to-gray-700 bg-[length:400%_100%]"
    ></div>
  </div>
</template>
